class LogoDirective {
  static directive($document) {
    'ngInject';
    return {
      restrict: 'A',
      template: `
        <img alt="F&F" class="logo" src="`+require("../../assets/logo.png")+`">
      `
    };
  }
}

export default LogoDirective.directive;



// WEBPACK FOOTER //
// ./src/commons/logo.directive.js